import React from "react";
import {Button, Columns, Heading, Modal, Section} from "react-bulma-components";




export default function MovementCheckModal({show, setShow}){

    return (
        <Modal
            show={show}
            onClose={() => setShow(false)}
        >
            <Modal.Content>
                <Section style={{background: "white"}}>
                    <Columns>
                        <Columns.Column>
                            <Heading>Do you need to create a movement?</Heading>
                        </Columns.Column>
                    </Columns>
                    <Columns>
                        <Columns.Column>
                            <Button
                                color={"info"}
                                onClick={() => setShow(false)}
                                fullwidth
                            >
                                Confirm
                            </Button>
                        </Columns.Column>
                    </Columns>
                </Section>
            </Modal.Content>
        </Modal>
    )


}